export const LANDING = {
  // Header
  headerLogo: "header-logo",
  headerCallNow: "header-call-now-button",
  navServices: "nav-services",
  navProcess: "nav-process",
  navArea: "nav-area",
  navPricing: "nav-pricing",
  navContact: "nav-contact",
  mobileMenuButton: "mobile-menu-button",

  // Hero
  heroGetQuote: "hero-get-quote-button",
  heroCallNow: "hero-call-now-button",
  heroShowcase: "hero-showcase-image",

  // Trust / info
  pricingValue: "pricing-value",
  warrantyCallout: "warranty-callout",
  serviceAreaBlock: "service-area-block",

  // Sticky CTA
  stickyCall: "sticky-call-button",
  stickyQuote: "sticky-quote-button",

  // Form
  quoteForm: "quote-form",
  quoteName: "quote-name-input",
  quotePhone: "quote-phone-input",
  quoteEmail: "quote-email-input",
  quoteVehicle: "quote-vehicle-input",
  quoteLocation: "quote-location-input",
  quoteDate: "quote-date-input",
  quoteTime: "quote-time-input",
  quoteMessage: "quote-message-textarea",
  quoteSubmit: "quote-submit-button",
  quoteSuccess: "quote-success-message",
  stepOneTextLink: "step-one-text-link",

  // Footer
  footerCall: "footer-call-link",
  footerEmail: "footer-email-link",
};
